"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historicalHolderImpressionsList = void 0;
const md_1 = require("react-icons/md");
const ri_1 = require("react-icons/ri");
const gi_1 = require("react-icons/gi");
const bi_1 = require("react-icons/bi");
const vsc_1 = require("react-icons/vsc");
const React = require("react");
const general_impression_config_1 = require("../config/general-impression.config");
exports.historicalHolderImpressionsList = [
    {
        id: 0,
        title: 'Preço alto!',
        subtitle: 'Dá pra melhorar',
        description: 'O preço deste ativo está mais alto que o normal, que tal esperar um pouco?',
        icon: React.createElement(md_1.MdMoneyOff, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'PRECO_ACIMA_NORMAL',
    },
    {
        id: 1,
        title: 'Preço baixo!',
        subtitle: 'Abaixo da média',
        description: 'Foi identificado que o preço deste ativo está mais baixo que o normal, talvez seja uma boa hora de comprar alguns papéis.',
        icon: React.createElement(md_1.MdAttachMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'PRECO_ABAIXO_NORMAL',
    },
    {
        id: 2,
        title: 'Paciência',
        subtitle: 'Com os preços',
        description: 'Foi identificado que o preço deste ativo está um pouco acima da média, talvez se você esperar mais um pouco pode obter por um preço mais baixo e maximizar seus lucros.',
        icon: React.createElement(md_1.MdMoneyOff, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'PACIENCIA_PRECOS',
    },
    {
        id: 3,
        title: 'Baixa',
        subtitle: 'Acumulada',
        description: 'Este ativo apresenta uma desvalorização de mais de 7% nos últimos meses.',
        icon: React.createElement(ri_1.RiBarChartGroupedFill, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 60,
        reportableIdentification: 'BAIXA_ACUMULADA_BAIXA',
    },
    {
        id: 4,
        title: 'Baixa',
        subtitle: 'Acumulada',
        description: 'Este ativo apresenta uma desvalorização de mais de 10% nos últimos meses.',
        icon: React.createElement(ri_1.RiBarChartGroupedFill, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 75,
        reportableIdentification: 'BAIXA_DEZ_PORCENTO',
    },
    {
        id: 5,
        title: 'Baixa',
        subtitle: 'Acumulada',
        description: 'O preço deste ativo acumula uma desvalorização de mais de 15% nos ultimos meses, fique alerta.',
        icon: React.createElement(ri_1.RiBarChartGroupedFill, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'BAIXA_QUINZE_PORCENTO',
    },
    {
        id: 6,
        title: 'Cuidado!',
        subtitle: 'Alta baixa acumulada',
        description: "Este ativo está 'ostentando' uma queda de mais de 25% nos últimos meses.",
        icon: React.createElement(gi_1.GiIncomingRocket, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 80,
        reportableIdentification: 'BAIXA_VINTECINCO_PORCENTO',
    },
    {
        id: 7,
        title: 'Cuidado!',
        subtitle: 'Baixa confirmada',
        description: 'Ladeira abaixo, este ativo está surfando em uma queda de mais de 50% nos últimos dias, olho nas breaking news.',
        icon: React.createElement(gi_1.GiIncomingRocket, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 85,
        reportableIdentification: 'BAIXA_CINQUENTA_PORCENTO',
    },
    {
        id: 8,
        title: 'Brutality!',
        subtitle: 'Incrivel',
        description: 'Este ativo conseguiu a façanha de acumular uma queda de mais de 60% nos últimos dias.',
        icon: React.createElement(gi_1.GiAfterburn, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 85,
        reportableIdentification: 'BAIXA_SESSENTA_PORCENTO',
    },
    {
        id: 9,
        title: 'Falcon?',
        subtitle: 'temos um problema',
        description: 'Este ativo está sobre uma incrível desvalorização de 50% nos últimos meses, tenha cuidado.',
        icon: React.createElement(gi_1.GiRocketThruster, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 90,
        reportableIdentification: 'BAIXA_CINQUENTA_PORCENTO',
    },
    {
        id: 10,
        title: 'Alta',
        subtitle: 'Acumulada',
        description: 'O preço deste ativo acumula uma valorização de mais de 7% nos últimos meses.',
        icon: React.createElement(ri_1.RiBarChartGroupedFill, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 70,
        reportableIdentification: 'ALTA_SETE_PORCENTO',
    },
    {
        id: 11,
        title: 'Alta',
        subtitle: 'Acumulada',
        description: 'O preço deste ativo acumula uma valorização de mais de 10% nos últimos meses.',
        icon: React.createElement(ri_1.RiBarChartGroupedFill, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 75,
        reportableIdentification: 'ALTA_DEZ_PORCENTO',
    },
    {
        id: 12,
        title: 'Alta',
        subtitle: 'acumulada',
        description: 'O preço deste ativo acumula uma valorização de mais de 15% nos últimos meses.',
        icon: React.createElement(gi_1.GiIncomingRocket, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 75,
        reportableIdentification: 'ALTA_QUINZE_PORCENTO',
    },
    {
        id: 13,
        title: 'To the Moon',
        subtitle: 'Alta Acumulada',
        description: 'O preço deste ativo surfa em uma alta de mais de 25% nos últimos meses.',
        icon: React.createElement(gi_1.GiRocketThruster, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 78,
        reportableIdentification: 'ALTA_VINTECINCO_PORCENTO',
    },
    {
        id: 14,
        title: 'Incrível',
        subtitle: 'Alta Acumulada',
        description: 'Este ativo está com uma acumulação de alta de mais de 55% nos últimos meses.',
        icon: React.createElement(gi_1.GiRunningNinja, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'ALTA_CINQUENTACINCO_PORCENTO',
    },
    {
        id: 15,
        title: 'Massacre',
        subtitle: 'Alta Acumulada',
        description: 'Este ativo está dominando com uma alta de mais de 65% nos últimos meses.',
        icon: React.createElement(gi_1.GiRunningNinja, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 82,
        reportableIdentification: 'ALTA_SESSENTACINCO_PORCENTO',
    },
    {
        id: 16,
        title: 'Ao Infinito',
        subtitle: 'e alem',
        description: "Este ativo está 'ostentando' uma explosão de valorização de mais de 75% nos últimos meses.",
        icon: React.createElement(gi_1.GiRocketThruster, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 85,
        reportableIdentification: 'ALTA_SETENTACINCO_PORCENTO',
    },
    {
        id: 17,
        title: 'Paciência',
        subtitle: 'é fundamental',
        description: 'Este ativo está com um preço próximo ao preço máximo atingido dias atrás, talvez se esperar, consiga preços melhores.',
        icon: React.createElement(bi_1.BiCoffee, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'PRECO_MUITO_ALTO_PACIENCIA',
    },
    {
        id: 18,
        title: 'Pertinho',
        subtitle: 'da maior baixa',
        description: 'Este ativo está com um preço próximo de sua maior baixa dos últimos meses, talvez seja uma boa oportunidade de comprar alguns papeis.',
        icon: React.createElement(gi_1.GiPayMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'PRECO_PROX_BAIXA',
    },
    {
        id: 19,
        title: 'Boa Liquidez',
        subtitle: 'Diaria',
        description: 'Este ativo está demonstrando facilidade de compra e venda de papéis, isso é um bom sinal.',
        icon: React.createElement(vsc_1.VscPieChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'BOA_LIQUIDEZ',
    },
    {
        id: 20,
        title: 'Boa Liquidez',
        subtitle: 'Diaria',
        description: 'Este ativo está demonstrando grande facilidade de compra e venda de papéis.',
        icon: React.createElement(vsc_1.VscPieChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'BOA_LIQUIDEZ',
    },
    {
        id: 21,
        title: 'Baixa liquidez',
        subtitle: 'Diaria',
        description: 'Este ativo está demonstrando certa dificuldade de compra e venda de papéis.',
        icon: React.createElement(vsc_1.VscPieChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'BAIXA_LIQUIDEZ',
    },
];
//# sourceMappingURL=historical-holder-impressions.js.map